import { merge } from 'lodash';
import { Input } from './Input';
import { Radio } from './Radio';
import { Switch } from './Switch';
import { Select } from './Select';
import { Checkbox } from './Checkbox';
import { ControlLabel } from './ControlLabel';
// ----------------------------------------------------------------------
export const Form = ({ theme }) => {
    return merge(Input({ theme }), Radio(), Switch({ theme }), Select(), Checkbox({ theme }), ControlLabel({ theme }));
};
//# sourceMappingURL=index.js.map